import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class DraftService extends BaseService {

    static url = "drafts";
    static apis = {
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("drafts");
    }

}

export default DraftService;